import styles from './AppPreloader.module.scss';
import { almi } from '../../../assets/images';

function AppPreloader() {
  return (
    <div className={styles.preloader}>
      <img
        className={styles.video}
        src={almi}
      />
    </div>
  );
}

export default AppPreloader;
